const EDIT_ORDER_CLAIM_DRAFT_PREFIX = 'admin:orderClaimDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeActionValue = (value) => (value === 'reject' ? 'reject' : 'approve')

const normalizeStringValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 클레임 상세는 운영자가 처리 중 다시 입력해야 하는 값만 sessionStorage에 남긴다.
export const createOrderClaimDraftPayload = ({
    action = 'approve',
    rejectReason = '',
    adminMemo = '',
    shippingAmount = 0,
} = {}) => {
    return {
        action: normalizeActionValue(action),
        rejectReason: normalizeStringValue(rejectReason),
        adminMemo: normalizeStringValue(adminMemo),
        shippingAmount: normalizeNumberValue(shippingAmount, 0),
    }
}

// 서버 기본 처리값 위에 draft만 덮어써서 새로고침 뒤에도 검토 흐름을 이어간다.
export const applyOrderClaimDraft = ({ baseDraft = {}, draft }) => {
    const normalizedBaseDraft = createOrderClaimDraftPayload(baseDraft)

    if (!draft) {
        return normalizedBaseDraft
    }

    return {
        action: normalizeActionValue(draft.action ?? normalizedBaseDraft.action),
        rejectReason: draft.rejectReason === undefined
            ? normalizedBaseDraft.rejectReason
            : normalizeStringValue(draft.rejectReason),
        adminMemo: draft.adminMemo === undefined
            ? normalizedBaseDraft.adminMemo
            : normalizeStringValue(draft.adminMemo),
        shippingAmount: draft.shippingAmount === undefined
            ? normalizedBaseDraft.shippingAmount
            : normalizeNumberValue(draft.shippingAmount, normalizedBaseDraft.shippingAmount),
    }
}

export const createEditOrderClaimDraftKey = (orderClaimId) => `${EDIT_ORDER_CLAIM_DRAFT_PREFIX}${orderClaimId}`

export const readOrderClaimDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveOrderClaimDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 처리 흐름은 그대로 유지한다.
    }
}

export const clearOrderClaimDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
